<mat-card>
    <mat-card-title>{{this.helpArticle.title}}</mat-card-title>
    <mat-card-content><div fxFill markdown>{{this.helpArticle.content}}</div></mat-card-content>
    <!-- End of content to update-->
    <mat-card-actions>
        <button mat-stroked-button color="primary" (click)="onNoClick()">Got It!</button>
    </mat-card-actions>
</mat-card>

